import React from "react";

function About() {
  return (
    <div className="about">
      <div className="container">
        <div className="row align-items-center my-5">
          <div className="col-lg-7">
            <div className="img"></div>
          </div>
          <div className="col-lg-5">
            <h1 className="font-weight-light">About</h1>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ducimus
              pariatur id aliquid maxime asperiores aut veniam quasi, recusandae
              nam, commodi voluptas facere inventore, obcaecati fugit magni.
              Quam, unde! Reiciendis provident ex maxime corporis quia explicabo
              ea, dolore culpa sit aperiam recusandae ad optio!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
